import logo from "./assets/logo/logo.svg";

import { Switch, Route, Link } from "react-router-dom";

import Backdrop from '@mui/material/Backdrop'
import Typography from '@mui/material/Typography'
import Lottie from 'react-lottie';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import { useAppSelector } from './hooks'

// pages
import Landing from "./pages/Landing";
import Campaign from './pages/campaign'
import Privacy from "./pages/Privacy";
import Pricing from "./pages/Pricing";
import Authenticate from "./pages/Authenticate";
import Dashboard from "./pages/admin/Dashboard";
import SelectStaffProfile from "./pages/admin/SelectStaffProfile";
import AdminLayout from "./pages/layouts/AdminLayout";
import OrganizationRegistration from "./pages/admin/OrganizationRegistration";

import { Auth, Amplify } from 'aws-amplify';
import awsconfig from './aws-exports'
import { Grid } from "@mui/material";
import DiscoveryCall from "./pages/campaign/DiscoveryCall";
import Discovery from "./pages/discovery";
import Ambassador from "./pages/ambassador";
Amplify.configure(awsconfig);

function App() {

  const loading = useAppSelector(state => state.loading)

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div style={{ zIndex: 1 }}>
        <Switch>
          <Route exact path="/">
            <Landing />
          </Route>
          <Route exact path="/campaign">
            <Campaign />
          </Route>
          <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
          <Route path="/campaign/discovery-call">
            <DiscoveryCall />
          </Route>
          <Route path="/discovery/:id">
            <Discovery />
          </Route>
          <Route path="/ambassador/:id">
            <Ambassador />
          </Route>
          <Route path="/privacy">
            <Privacy />
          </Route>
          {/* <Route path="/pricing">
            <Pricing />
          </Route> */}
          <Route path="/authenticate">
            <Authenticate />
          </Route>
        </Switch>
      </div>
      <div style={{ zIndex: 2000 }}>
        <Backdrop
          sx={{ color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(5px)', position: 'absolute' }}
          open={loading.activeLoads > 0}
        >
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: require('./assets/animations/flourish_loading_green.json'),
            }}
            speed={2}
            height={50}
            width={50}
          />
          <br /><br />
          <Typography variant="body1">{loading.message}</Typography>
        </Backdrop>
      </div>
    </LocalizationProvider>

  );
}

export default App;
